(function () {
	'use strict';

    const module = angular.module('imApp');

    module.component('batchDeliverySelectPurchHead', {
        templateUrl: 'views/components/views/batchDeliverySelectPurchHead/batchDeliverySelectPurchHead.template.html?v=' + module.version,
		controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'batchDeliverySelectPurchHeadService', 'rememberService', function ($stateParams, stateService, batchDeliverySelectPurchHeadService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let supplierNo = $stateParams.supplier_no;
            let batchDeliveryKeyno = $stateParams.batchdelivery_keyno;

            vm.model = {
                searchTextButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.searchtext = '' }
                ],
                setting: {},
                itemsListPurchaseOrders: [],
                showChecked: false,
                itemsChecked: false,
                lockedChosenSelected: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALLS
            
            async function loadSetting() {
                vm.model.setting = (await batchDeliverySelectPurchHeadService.getSetting({
                    supplier_no: supplierNo,
                    batchdelivery_keyno: batchDeliveryKeyno
                }))[0];
            }

            async function loadPurchaseOrders() {
                vm.model.itemsListPurchaseOrders = await batchDeliverySelectPurchHeadService.listPurchaseOrders({
                    supplier_no: supplierNo,
                    batchdelivery_keyno: batchDeliveryKeyno
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region TOGGLE CHOSEN FUNCTION

            vm.toggleChosen = function (item) {
                if (item.item_id === '0') return;
                if (item.item_id === '-1') return;

                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                    item.item_glyphicon_color = 'green';
                    vm.model.itemsChecked = true;
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                    item.item_glyphicon_color = 'black';
                    vm.model.itemsChecked = false;
                }
            };

            // #endregion TOGGLE CHOSEN FUNCTION

            // #region SELECT ALL LIST BUTTON FUNCTION

            vm.selectAll = function () {
                vm.model.showChecked = true;

                vm.model.itemsListPurchaseOrders.forEach((item) => {
                    if (item.item_filtervalue.toLowerCase().indexOf(vm.model.setting.searchtext.toLowerCase()) <= -1) return;
                    if (item.item_id === '0' || item.item_id === '-1') return;

                    item.item_is_selected = '1';
                    item.item_glyphicon_color = 'green';
                    vm.model.itemsChecked = true;
                });
            }

            // #endregion SELECT ALL LIST BUTTON FUNCTION

            // #region UNSELECT ALL LIST FUNCTION

            vm.unselectAll = function () {
                vm.model.showChecked = false;

                vm.model.itemsListPurchaseOrders.forEach((item) => {
                    if (item.item_filtervalue.toLowerCase().indexOf(vm.model.setting.searchtext.toLowerCase()) <= -1) return;
                    if (item.item_id === '0' || item.item_id === '-1') return;

                    item.item_is_selected = '0';
                    item.item_glyphicon_color = 'black';
                    vm.model.itemsChecked = false;
                });
            }

            // #endregion UNSELECT ALL LIST FUNCTION

            // #region CHOOSE SELECTED FUNCTION

            vm.chooseSelected = function () {
                vm.model.lockedChosenSelected = true;
                let purchInternalNos = '';
                let itemState = '';
                let itemParms = '';

                vm.model.itemsListPurchaseOrders.forEach((item) => {
                    if (item.item_is_selected === '1') {
                        if (purchInternalNos > '') {
                            purchInternalNos = purchInternalNos + ',';
                        }

                        purchInternalNos = purchInternalNos + item.item_id;
                        itemState = item.item_state;
                        itemParms = item.item_parms;
                    }
                });

                if (purchInternalNos > '') {
                    rememberService.remember('batchdeliverypurchhead.purch_internal_nos', purchInternalNos).then(() => {
                        vm.model.lockedChosenSelected = false;

                        stateService.go(itemState, itemParms);
                    });
                } else {
                    vm.model.lockedChosenSelected = false;
                }
            }

            // #endregion CHOOSE SELECTED FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                loadSetting();
                loadPurchaseOrders();
            }

            // #endregion ON INIT FUNCTION

		}]
	});
})();
